import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {ToastService} from "../../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {Session} from "../../../services/Session";
import {environment} from "../../../../environments/environment";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ModelBasedNumeral} from "../../../directives/model-numeral";
import {FroalaEditorModule} from "angular-froala-wysiwyg";

declare let _: any;

@Component({
  selector: 'app-vendor-strategies',
  standalone: true,
  imports: [CommonModule, FormsModule, ModelBasedNumeral, FroalaEditorModule, FileUploadModule],
  templateUrl: './vendor-strategies.component.html',
  styleUrl: './vendor-strategies.component.scss'
})
export class VendorStrategiesComponent implements OnInit, OnDestroy {
  org: string = Session.getOrg();
  user: any = {};
  @Input() strategies: any;
  @Input() vendorIdForCreate: any;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('vendorStrategiesInfo', { static: true }) vendorStrategiesInfo!: TemplateRef<any>;

  fileUploader: FileUploader;
  hasFileBaseDropZoneOver: boolean;
  videoUploader: FileUploader;
  hasVideoBaseDropZoneOver: boolean;
  imageUploader: FileUploader;
  hasImageBaseDropZoneOver: boolean;

  currentSelectedStrategy: any;
  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Enter Offer description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  currentEnvironment: any;


  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private taxStrategyServices: ManageTaxStrategiesServices,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.vendorStrategiesInfo);
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.currentEnvironment = environment;
    if (this.strategies && this.strategies.length > 0) {
      this.selectStrategy(this.strategies[0]);
    }
  }

  selectStrategy(strategy) {
    this.currentSelectedStrategy = strategy;
    this.setFileUploader();
    this.setImageUploader();
    this.setVideoUploader();

    _.each(this.strategies, (obj) => {
      if(obj.strategyName === strategy.strategyName) {
        obj.selected = true;
      } else {
        obj.selected = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.viewContainerRef.clear();
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  fileDropOver($event, type?){
    this.loadingService.triggerLoadingEvent(true);
    if (type) {
      if (type === 'file') {
        this.fileUploader.uploadAll();
      } else if (type === 'image') {
        this.imageUploader.uploadAll();
      } else if (type === 'video') {
        this.videoUploader.uploadAll();
      }
    }
  }

  fileOverBase($event, type?){
    if (type) {
      if (type === 'file') {
        this.hasFileBaseDropZoneOver = $event;
      } else if (type === 'image') {
        this.hasImageBaseDropZoneOver = $event;
      } else if (type === 'video') {
        this.hasVideoBaseDropZoneOver = $event;
      }
    }
  }

  setFileUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user);
    this.fileUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.fileUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.fileUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.vendorIdForCreate;
      payload.sourceType = 'VENDOR_FILE';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.fileUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.fileUploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.viewDocContentURL;
          obj['fileType'] = this.getFileType(document);
          this.currentSelectedStrategy.files.push(obj);
        }
      } else {
        this.resetUploader('file');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document(s)');
      }
    };
  }

  setImageUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user);
    this.imageUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.imageUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.imageUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.vendorIdForCreate;
      payload.sourceType = 'vendor';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.imageUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.imageUploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = ((this.currentEnvironment.production) ? 'https://documents.taxplaniq.com/' : 'https://dev-documents.taxplaniq.com/') + document.id;
          this.currentSelectedStrategy.images.push(obj);
        }
      } else {
        this.resetUploader('image');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload image(s)');
      }
    };
  }

  setVideoUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, this.user);
    this.videoUploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.videoUploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.videoUploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.vendorIdForCreate;
      payload.sourceType = 'VENDOR_VIDEO';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.videoUploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.videoUploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.viewDocContentURL;
          this.currentSelectedStrategy.videos.push(obj);
        }
      } else {
        this.resetUploader('video');
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload video(s)');
      }
    };
  }

  resetUploader(type?) {
    if (type) {
      if (type === 'file') {
        this.fileUploader.queue.forEach((item) => {
          item.remove();
        });
      } else if (type === 'image') {
        this.imageUploader.queue.forEach((item) => {
          item.remove();
        });
      } else if (type === 'video') {
        this.videoUploader.queue.forEach((item) => {
          item.remove();
        });
      }
    }
  }

  getFileType(file) {
    let type = '';
    const splitArray = file.name.split('.');
    if (splitArray[splitArray.length - 1] === 'pdf' || splitArray[splitArray.length - 1] === 'PDF') {
      type = 'pdf';
    } else if (this.isExcel(splitArray[splitArray.length - 1])) {
      type = 'excel';
    }

    return type;
  }

  isExcel(extension){
    const types = ['xls', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xlt', 'xltm', 'xltm', 'xltm'];
    if (types.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  deleteDocumentFile(file, index, type?){
    if (type) {
      if (type === 'file') {
        this.currentSelectedStrategy.files.splice(index, 1);
      } else if (type === 'image') {
        this.currentSelectedStrategy.images.splice(index, 1);
      } else if (type === 'video') {
        this.currentSelectedStrategy.videos.splice(index, 1);
      }
    }
  }

  setStrategyOfferType(type) {
    if (type === 'percentage') {
      this.currentSelectedStrategy.offer.offerType = 'percentage';
    } else if (type === 'price') {
      this.currentSelectedStrategy.offer.offerType = 'price';
    }
  }

}
